/**
 * Standalone Bob chat — reachable straight from the Design Check nav, no
 * uploaded part required. Bob answers general DFM questions from the design
 * guide and PE320 rules, and suggests a STEP upload for part-specific checks.
 */

import React from 'react';
import DesignCheckLayout from './DesignCheckLayout';
import AdvisorChat from '../../components/design-check/AdvisorChat';
import './DesignCheck.css';

function ChatPage() {
  return (
    <DesignCheckLayout>
      <div className="dc-chat-page">
        <div className="dc-hero" style={{ marginBottom: 18 }}>
          <h1>Ask Bob</h1>
          <p>
            Design-for-manufacture advice for large-format robotic pellet
            printing — wall thickness, orientation, materials, overhangs.
            Upload a part from "My parts" when you want a full check.
          </p>
        </div>
        <div className="dc-card dc-chat-page-card">
          <AdvisorChat jobId={null} />
        </div>
      </div>
    </DesignCheckLayout>
  );
}

export default ChatPage;
